import { CSSProperties } from 'react'
import styled from 'styled-components'
import { Box, Colors } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SplitButtonGroupContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 8px;
  row-gap: 14px;
`
export const SplitButton = styled.button.attrs({ type: 'button' })<{
  isSelected?: boolean
}>`
  background: ${({ isSelected }) => (isSelected ? Colors.hover : Colors.white)};
  color: ${({ isSelected }) => (isSelected ? Colors.primary_600 : Colors.dark)};
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.56px;
  border-width: 1px;
  border-radius: 4px;
  border-color: ${({ isSelected }) =>
    isSelected ? Colors.primary_600 : Colors.border};
  border-style: solid;
  cursor: pointer;
  padding: 9px 16px;

  &:disabled {
    cursor: not-allowed;
    background: ${Colors.disabled};
    border-color: ${Colors.border} !important;
    color: ${Colors.dark} !important;
  }

  &:hover {
    border-color: ${Colors.primary_600};
    color: ${Colors.primary_600};
  }
`

// This container is used only for measurement purposes – it is rendered off-screen
// so that we can obtain the intrinsic widths of all buttons without affecting the
// layout. We keep it fixed and invisible.
export const HiddenMeasureContainer = styled.div`
  position: fixed;
  visibility: hidden;
  pointer-events: none;
  top: -9999px;
  left: -9999px;
  height: 0;
  overflow: hidden;
`

export const SplitButtonIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
  color: ${Colors.dark};
  margin-left: 6px;
`

export const dropDownMenuStyles: CSSProperties = {
  borderRadius: '4px',
  boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
}
